import React, { useState } from 'react';
import { useLoaderData } from '@tanstack/react-router';

import {
  APIacceptTimelineContributor,
  APIdeclineTimelineContributor,
} from '../api/Timeline';

import TimelineHeader from '../components/Timeline/Header';
import Notices from '../components/Notices';

import type { Contributor } from '../types/contributor';

import { useStore } from '../store';

const TimelineContributorAccept: React.FC = () => {
  const { timeline, contributorId } = useLoaderData({ strict: false });
  const { profile } = useStore();
  const mode = 'public';

  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  const acceptInvitation = async () => {
    setError(null);
    setSaving(true);
    try {
      await APIacceptTimelineContributor(timeline.id, contributorId);
      window.location.href = `/timelines/${timeline.id}`;
    } catch (error) {
      console.error('Error accepting invitation:', error);
      setError((error as Error).message || 'An error occurred while accepting the invitation.');
    } finally {
      setSaving(false);
    }
  };

  const declineInvitation = async () => {
    setError(null);
    setSaving(true);
    try {
      await APIdeclineTimelineContributor(timeline.id, contributorId);
      window.location.href = `/timelines/${timeline.id}`;
    } catch (error) {
      console.error('Error declining invitation:', error);
      setError((error as Error).message || 'An error occurred while declining the invitation.');
    } finally {
      setSaving(false);
    }
  };

  const userNotInvited = timeline.contributor?.user?.id !== profile?.id;
  const invitedUser = timeline.contributors.find((contributor: Contributor) => contributor.id === contributorId);

  return (
    <div className="container timeline-view-container timeline-contributor-container">
      <div className="timeline-header wa-stack wa-gap-0 inner">
        <Notices />
        <TimelineHeader
          timeline={timeline}
          mode={mode}
        />
      </div>
      <div className="wa-stack wa-gap-2xs timeline-contributor-container-inner">
        {error && (
          <wa-callout variant="danger">
            {error}
          </wa-callout>
        )}
        {userNotInvited ? (
          <wa-callout variant="danger" className="center">
            <strong>You have not been invited to contribute to this Timeline.</strong>
            {invitedUser && (
              <>
                <br />
                This invite has been sent to <strong>{invitedUser?.email}</strong> email address.
              </>
            )}
          </wa-callout>
        ) : (
          <>
            <p>
              {timeline.user.name} invited you to contribute to this Timeline.
            </p>
            <p>
              After you accept the invitation, you will be able to add Memories to this Timeline.
            </p>
            <div className="wa-cluster wa-gap-2xs">
              <wa-button href={`/timelines/${timeline.id}`} target="_blank">
                View Timeline
              </wa-button>
            </div>
            <div className="wa-cluster wa-gap-2xs">
              <wa-button onClick={acceptInvitation} disabled={saving}>
                Accept Invitation
              </wa-button>
              <wa-button onClick={declineInvitation} disabled={saving}>
                Decline Invitation
              </wa-button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default TimelineContributorAccept;
